// eslint-disable-next-line no-restricted-imports
import { I18nProvider as LinguiI18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { useInitializeLocale } from "@src/hooks";
import type { ReactNode } from "react";

type I18nProviderProps = {
  readonly children: ReactNode;
};

export const I18nProvider = ({ children }: I18nProviderProps) => {
  useInitializeLocale();

  return <LinguiI18nProvider i18n={i18n}>{children}</LinguiI18nProvider>;
};
